import React from 'react'
import { useCookies } from 'react-cookie'
import Icon from 'components/elements/Icon'

import styles from './collapsibleContentContainer.module.scss'

type Props = {
  name: string
  nameExtras?: string // renders after the name as a dynamic value
  children: React.ReactNode
  className?: string
  defaultCollapsed?: boolean // will be superseded by local storage
}

const CollapsibleContentContainer = ({ name, nameExtras = '', children, className = '', defaultCollapsed }: Props) => {
  const cookieKey = name.replace(/\s/g, '')
  const [{ [cookieKey]: openCookieValue = `${!defaultCollapsed}` }, setCookies] = useCookies([cookieKey])
  const open = openCookieValue === 'true'

  const handleToggleOpenState = () => {
    setCookies(cookieKey, !open)
  }

  return (
    <div className={`${styles.container} ${open ? className : ''}`}>
      {/* Buttons are written this way because the conditional would be more messy */}
      {open && (
        <button title="Minimize" className={styles.minimizeButton} onClick={handleToggleOpenState}>
          <Icon name="window minimize" />
        </button>
      )}
      {!open && (
        <button title="Expand" onClick={handleToggleOpenState} className={styles.expandButton}>
          <span>Expand section</span>
          <Icon className={styles.maximizeIcon} name="arrows alternate vertical" />
        </button>
      )}

      {!open && (
        <h5 className={styles.minimizedName}>
          {name} {nameExtras}
        </h5>
      )}
      {open && children}
    </div>
  )
}

export default CollapsibleContentContainer
